import fetch from '../../api/fetch';
import { REDUX_ACTIONS } from '../../shared/config/constants';
import { parseError } from '../../utils/fetchErrorParser';
import { modifyMetricData } from '../../utils/getMetrics';
import { generateMongoLikeId } from '../../utils/uuidGenerator';
import store from '../store';
import { enqueueSnackbar } from './snackbar';
import { listWells } from './wells';

function generateRandom() {
  const length = 24;
  const charset = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let retVal = '';
  for (let i = 0, n = charset.length; i < length; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n));
  }
  return retVal;
}

export const listDrillFluid = (wellId, closeDialog) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.WELLS_DRILL_FLUID_LIST_LOADING,
  });
  const body = {
    query: {
      wellsInfoId: wellId
    }
  };
  return fetch
    .post('wells/entity/drillFluid/fetch', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then((data) => {
      const { currentUser } = store.getState();
      const currentUnit = currentUser?.preferences?.unitSystem;
      const { data: drillFluidData, units } = data;
      const modifiedDrillFluidData = modifyMetricData(drillFluidData, units, currentUnit);
      dispatch({
        type: REDUX_ACTIONS.WELLS_DRILL_FLUID_LIST_SUCCESS,
        payload: {
          ...data,
          data: modifiedDrillFluidData,
          paginatedElements: modifiedDrillFluidData.length,
          units: data.units
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      if (error?.status === 403) {
        closeDialog?.();
      }
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.WELLS_DRILL_FLUID_LIST_ERROR,
        payload: { ...error, message: 'Error' },
      });
    });
};

export const addNewDrillFluidRow = () => (dispatch) => {
  const { wellsDrillFluid } = store.getState();
  const newDrillFluid = [...wellsDrillFluid.data];
  const existUnit = { ...wellsDrillFluid.units };
  const nextId = newDrillFluid.length - 1;
  const newRow = {
    name: '',
    MD: '',
    details: [],
    lastUpdate: new Date(),
    grid_id: nextId + 1,
    _id: generateRandom(),
    isNewRow: true,
    isDirty: true,
  };
  newDrillFluid.unshift(newRow);
  dispatch({
    type: REDUX_ACTIONS.WELLS_DRILL_FLUID_LIST_SUCCESS,
    payload: {
      data: newDrillFluid,
      units: existUnit,
      paginatedElements: newDrillFluid.length,
    },
  });
};

export const createDrillFluid = (body, wellId, details) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.WELLS_DRILL_FLUID_LIST_LOADING,
  });
  delete body._id;
  delete body?.isNewRow;
  delete body?.isDirty;
  delete body?.lastUpdate;
  delete body?.grid_id;
  const input = {
    input: {
      ...body,
      wellsInfoId: wellId
    }
  };
  return fetch
    .post('wells/entity/drillFluid/create', input)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then((data) => {
      if (details) {
        dispatch({
          type: REDUX_ACTIONS.WELLS_DRILL_FLUID_SET_ID,
          payload: {
            data: data.data._id,
          },
        });
      }
      dispatch(
        enqueueSnackbar(
          'Drill Fluid Created Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listDrillFluid(wellId));
      dispatch(listWells());
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
      dispatch(listDrillFluid(wellId));
    });
};
export const updateDrillFluid = (body) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.WELLS_DRILL_FLUID_LIST_LOADING,
  });
  delete body?.isNewRow;
  delete body.isDirty;
  const input = {
    query: {
      _id: body?._id
    },
    input: {
      ...body
    }
  };
  return fetch
    .put('wells/entity/drillFluid', input)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Drill Fluid Updated Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listDrillFluid(body?.wellsInfoId));
      dispatch(listWells());
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
      dispatch(listDrillFluid(body?.wellsInfoId));
    });
};
export const deleteDrillFluidRow = (deleteDrillFluidId, wellId, wellInfoId) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.WELLS_DRILL_FLUID_LIST_LOADING,
  });
  const body = {
    query: {
      _id: deleteDrillFluidId,
      wellsInfoId: wellInfoId
    }
  };
  return fetch
    .deleteAction('wells/entity/drillFluid', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Drill fluid deleted successfully',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listDrillFluid(wellId));
      dispatch(listWells());
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
      dispatch(listDrillFluid(wellId));
    });
};
export const updateDrillFluidDetails = (data) => (dispatch) => {
  const { wellsDrillFluid } = store.getState();
  const currentDrillFluid = [...wellsDrillFluid.data];
  const index = currentDrillFluid.findIndex(drillstring => drillstring._id === data._id);
  currentDrillFluid[index] = data;
  dispatch({
    type: REDUX_ACTIONS.WELLS_DRILL_FLUID_LIST_SUCCESS,
    payload: {
      data: currentDrillFluid,
      paginatedElements: currentDrillFluid.length,
    },
  });
};
export const importDrillFluidDetails = (data) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.WELLS_DRILL_FLUID_LIST_LOADING,
  });
  const drillFluidList = data.sort((a, b) => a.md - b.md).map((value, index) => {
    return {
      ...value,
      id: generateRandom(),
      grid_id: index,
      _id: index
    };
  });
  setTimeout(() => {
    dispatch({
      type: REDUX_ACTIONS.WELLS_DRILL_FLUID_LIST_SUCCESS,
      payload: {
        data: drillFluidList,
        paginatedElements: drillFluidList.length,
      }
    });
    dispatch(
      enqueueSnackbar(
        'CSV file imported Successfully.',
        'success',
        new Date().getTime() + Math.random()
      ));
  }, 2000);
};

export const listDrillFluidDetails = (drillId) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.WELLS_DRILL_FLUID_DETAILS_LIST_LOADING,
  });
  const body = {
    query: {
      drillId
    }
  };
  return fetch
    .post('wells/entity/drillFluid/properties/fetch', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then((data) => {
      const { currentUser } = store.getState();
      const currentUnit = currentUser?.preferences?.unitSystem;
      const { data: drillFluidDetailsData, units } = data;
      units.rheo_data = {
        fann_s_stress: { ...units.yp },
        shear_str: {
          api_rp_ypl: { ...units.yp },
          bingham: { ...units.yp },
          newtonian: { ...units.yp },
          api_rp_ypl_fit: { ...units.yp },
          pl: { ...units.yp },
          ypl: { ...units.yp },
        }
      };
      const rheoData = drillFluidDetailsData?.[0]?.rheo_data;
      const rheoUnits = units?.rheo_data;
      let modifiedFannSStress;
      let modifiedShearStr;
      if (rheoData) {
        modifiedFannSStress = Array.isArray(rheoData?.fann_s_stress)
          ? modifyMetricData(
            rheoData.fann_s_stress.map((val) => ({ fann_s_stress: val })),
            rheoUnits,
            currentUnit
          ).map((item) => item.fann_s_stress)
          : [];
        modifiedShearStr = rheoData?.shear_str
          ? Object.fromEntries(
            Object.entries(rheoData.shear_str).map(([model, arr]) => [
              model,
              modifyMetricData(
                arr.map((val) => ({ [model]: val })),
                { [model]: rheoUnits?.shear_str?.[model] },
                currentUnit
              ).map((item) => item[model])
            ])
          )
          : {};
      }
      const modifiedDrillFluidDetailsData = modifyMetricData(drillFluidDetailsData, units, currentUnit);
      if (rheoData) {
        modifiedDrillFluidDetailsData[0].rheo_data.fann_s_stress = modifiedFannSStress;
        modifiedDrillFluidDetailsData[0].rheo_data.shear_str = modifiedShearStr;
      }

      dispatch({
        type: REDUX_ACTIONS.WELLS_DRILL_FLUID_DETAILS_LIST_SUCCESS,
        payload: {
          data: modifiedDrillFluidDetailsData,
          paginatedElements: modifiedDrillFluidDetailsData.length,
          units: data.units
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.WELLS_DRILL_FLUID_DETAILS_LIST_ERROR,
        payload: { ...error, message: 'Error' },
      });
    });
};

export const createDrillFluidDetailsProperty = (drillId, body, wellsInfoId) => async (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.WELLS_DRILL_FLUID_DETAILS_LIST_LOADING,
  });

  delete body._id;

  const input = {
    query: {
      drillId,
      wellsInfoId,
    },
    input: body,
  };

  try {
    const result = await fetch.post('wells/entity/drillFluid/properties/create', input);

    if (!result.ok) {
      throw result;
    }

    await result.json();

    dispatch(
      enqueueSnackbar(
        'Drill Fluid Details Property Created Successfully.',
        'success',
        new Date().getTime() + Math.random()
      )
    );

    await dispatch(runHydraulicsUpdateMud(drillId));

    dispatch(listDrillFluidDetails(drillId));
    dispatch(listWells());
    dispatch(listDrillFluid(wellsInfoId));
  } catch (error) {
    const errorMessage = await parseError(error);

    dispatch(
      enqueueSnackbar(
        errorMessage,
        'error',
        new Date().getTime() + Math.random()
      )
    );

    dispatch(listDrillFluidDetails(drillId));
    dispatch(listDrillFluid(wellsInfoId));
  }
};

export const updateDrillFluidDetailsProperty = (drillId, _id, body, wellsInfoId) => async (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.WELLS_DRILL_FLUID_DETAILS_LIST_LOADING,
  });
  const input = {
    query: {
      drillId,
      wellsInfoId,
      _id
    },
    input: body
  };

  try {
    const result = await fetch.put('wells/entity/drillFluid/properties', input);

    if (!result.ok) {
      throw result;
    }

    await result.json();

    dispatch(
      enqueueSnackbar(
        'Drill Fluid Details Property Updated Successfully.',
        'success',
        new Date().getTime() + Math.random()
      )
    );

    await dispatch(runHydraulicsUpdateMud(drillId));

    dispatch(listDrillFluidDetails(drillId));
    dispatch(listWells());
    dispatch(listDrillFluid(wellsInfoId));
  } catch (error) {
    const errorMessage = await parseError(error);
    dispatch(
      enqueueSnackbar(
        errorMessage,
        'error',
        new Date().getTime() + Math.random()
      )
    );

    dispatch(listDrillFluidDetails(drillId));
    dispatch(listDrillFluid(wellsInfoId));
  }
};

export const deleteDrillFluidDetailsProperty = (drillId, _id, wellsInfoId) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.WELLS_DRILL_FLUID_DETAILS_LIST_LOADING,
  });
  const input = {
    query: {
      drillId,
      wellsInfoId,
      _id
    },
  };
  return fetch
    .deleteAction('wells/entity/drillFluid/properties', input)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Drill Fluid Details Property  Deleted Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listDrillFluidDetails(drillId));
      dispatch(listWells());
      dispatch(listDrillFluid(wellsInfoId));
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
    });
};

export const copyDrillFluidRow = (row) => (dispatch) => {
  const { wellsDrillFluid } = store.getState();
  const newDrillFluid = [...wellsDrillFluid.data];
  const existUnit = { ...wellsDrillFluid.units };
  const newRow = {
    name: '',
    MD: '',
    details: row.details?.map(item => ({
      ...item,
      _id: generateMongoLikeId(),
    })) || [],
    _id: generateRandom(),
    isNewRow: true,
    isDirty: true,
    permissionId: row?.permissionId || undefined
  };
  newDrillFluid.unshift(newRow);
  dispatch({
    type: REDUX_ACTIONS.WELLS_DRILL_FLUID_LIST_SUCCESS,
    payload: {
      data: newDrillFluid,
      units: existUnit,
      paginatedElements: newDrillFluid.length,
    },
  });
};

export const runHydraulicsUpdateMud = (drillId) => (dispatch) => {
  const input = {
    input: {
      url: '/muds/update',
      method: 'POST',
      data: {
        fluid_id: drillId
      }
    }
  };
  return fetch
    .post('premiumHydraulics/proxy', input)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Mud Data Updated Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
    });
};
